import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import axios from "axios";
import PropTypes from "prop-types";
import { WarningPopUp, Image } from "hesus-ui-kit";

import { FlexRow } from "./SolutionsActions.styled";
import { handleApiError } from "@utils/errorHandler";
import AddEditSolution from "../../../AddEditSolution";
import EnquirySellingPriceValidated from "../../../../SellingPrice/SellingPricesList/components/EnquirySellingPrice/EnquirySellingPriceValidated";
import { solutionsActions } from "@utils/constants";

import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import cancelIcon from "@icons/ic-cancel.svg";
import greenYesIcon from "@icons/ic-yes-green.svg";
import "../../SolutionsList.scss";

const SolutionsActions = (props) => {
  const {
    t,
    data,
    onRefreshData,
    enquiryService,
    enquirySubCategoryName,
    enquirySubCategoryId,
    enquiryId,
    countryId,
  } = props;

  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [action, setActionState] = useState("");
  const [currentSolution, setCurrentSolution] = useState(null);
  const [filterSellingPrice, setFilterSellingPrice] = useState([]);
  const [sellingPriceItemIds, setSellingPriceItemIds] = useState([]);
  const [isSolutionValidatedPopupVisible, setSolutionValidatedPopupVisible] =
    useState(false);
  const [isAddSolutionPopupVisible, setAddSolutionPopupVisibility] =
    useState(false);
  const [isSolutionValidating, setIsSolutionValidating] = useState(false);

  const fetchSellingPrices = (solutionId) => {
    let url = "";
    if (data.priceType === 4) {
      url = `/v2/sellingPrices?siteId=${data.siteId}&requestId=${data.requestId}&solutionId=${solutionId}&productId=${data?.productId}&active=1`;
    } else {
      let selectedTransportPrice = [];
      selectedTransportPrice = data?.solutionTransportPrices?.filter(
        (price) => price.selectedPrice
      );
      const tranportId = selectedTransportPrice?.[0]?.transportType?.id;
      url = `/v2/sellingPrices?siteId=${data.siteId}&requestId=${data.requestId}&solutionId=${solutionId}&transports=[${tranportId}]&active=1`;
    }

    axios
      .get(url)
      .then((response) => {
        if (response.data?.sellingPrices?.length > 0) {
          const itemIds = [];
          response.data?.sellingPrices.map((data) => {
            data.services?.map((service) => {
              service.solutions?.map((solutionData) => {
                if (
                  parseInt(solutionData?.solution?.id, 10) ===
                  parseInt(solutionId, 10)
                ) {
                  itemIds.push(parseInt(service.id, 10));
                }
              });
            });
          });
          setSellingPriceItemIds(itemIds);
          setFilterSellingPrice(response.data?.sellingPrices);
          setSolutionValidatedPopupVisible(true);
        } else {
          setSellingPriceItemIds([]);
          setFilterSellingPrice([]);
          setSolutionValidatedPopupVisible(false);
          setActionState(solutionsActions.VALIDATE);
        }
      })
      .catch((error) => handleApiError(error));
  };
  const onSolutionValidatedPopupClose = () => {
    setActionState(solutionsActions.VALIDATE);
    setSolutionValidatedPopupVisible(false);
  };
  const onSolutionValidateSubmit = () => {
    setIsSolutionValidating(true);
    setActionState(solutionsActions.SOLUTION_VALIDATE);
    setSolutionValidatedPopupVisible(false);
  };

  const handleSolutionDisable = () => {
    setConfirmVisibility(true);
    setActionState(solutionsActions.DISABLE);
  };

  const handleSolutionValidate = () => {
    fetchSellingPrices(data.id);
  };

  const editSolution = () => {
    axios
      .get(`/solutions/${data.id}`)
      .then((response) => {
        setCurrentSolution(response.data[0]);
        setAddSolutionPopupVisibility(true);
      })
      .catch((error) => handleApiError(error));
  };

  const closeSolutionCreationPopup = () => {
    setAddSolutionPopupVisibility(false);
    onRefreshData(true);
  };

  const handleSolutionInValidate = () => {
    setActionState(solutionsActions.INVALIDATE);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (isConfirm && action) {
      if (action === solutionsActions.DISABLE) {
        axios
          .delete(`/solutions/${data.id}`)
          .then(() => {
            onRefreshData(true);
          })
          .catch((error) => handleApiError(error));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm, action, data.id]);

  useEffect(() => {
    if (action) {
      const request = {
        type: "",
        url: "",
      };
      let status;
      switch (action) {
        case solutionsActions.ACTIVATE:
          request.type = "delete";
          request.url = `/solutions/${data.id}`;
          break;
        case solutionsActions.SELECT:
          status = 4; // SELECTED
          if (data.selectedPrice) {
            status = 6; // TRANSPORT_QUOTED
          }
          request.type = "put";
          request.url = `/solutions/${data.id}/updateStatus/${status}`;
          break;
        case solutionsActions.DESELECT:
          status = 1; // INITIATED
          if (data.solutionTypeId === 3) {
            status = 3; // VALIDATED_SUPPLIER
          }
          request.type = "put";
          request.url = `/solutions/${data.id}/updateStatus/${status}`;
          break;
        case solutionsActions.INVALIDATE:
          status = 6; // TRANSPORT_QUOTED
          request.type = "put";
          request.url = `/solutions/${data.id}/updateStatus/${status}`;
          break;
        case solutionsActions.VALIDATE:
          status = 7; // VALIDATED
          request.type = "put";
          request.url = `/solutions/${data.id}/updateStatus/${status}`;
          break;
        case solutionsActions.SOLUTION_VALIDATE:
          status = 7; // VALIDATED
          request.type = "update";
          request.url = `/solutions/${data.id}/updateStatus/${status}`;
          break;
        default:
      }

      if (request.type === "put") {
        axios
          .put(request.url)
          .then(() => {
            onRefreshData(true);
          })
          .catch((error) => handleApiError(error));
      }
      if (request.type === "update") {
        const formData = {
          solutionId: data.id,
          statusId: status,
          sellingPriceItems: JSON.stringify(sellingPriceItemIds),
        };
        axios
          .put(request.url, formData)
          .then(() => {
            onRefreshData(true);
          })
          .catch((error) => handleApiError(error));
        setIsSolutionValidating(false);
      }
      if (request.type === "delete") {
        axios
          .delete(request.url)
          .then(() => {
            onRefreshData(true);
          })
          .catch((error) => handleApiError(error));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    action,
    data.id,
    data.priceType,
    data.selectedPrice,
    data.solutionTypeId,
  ]);

  useEffect(() => {
    onRefreshData(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FlexRow>
      {isSolutionValidatedPopupVisible && (
        <EnquirySellingPriceValidated
          onClose={onSolutionValidatedPopupClose}
          sellingPriceData={filterSellingPrice}
          sellingPriceItemIds={sellingPriceItemIds}
          setSellingPriceItemIds={setSellingPriceItemIds}
          onSolutionValidateSubmit={onSolutionValidateSubmit}
          isSolutionValidating={isSolutionValidating}
        />
      )}
      <>
        {data.isActive === 1 && data.status === 6 && (
          <Image
            src={greenYesIcon}
            onClick={handleSolutionValidate}
            alt={t("SOLUTION_ACTION_TOOLTIP_VALIDATE")}
            title={t("SOLUTION_ACTION_TOOLTIP_VALIDATE")}
            className="solutions-list__image-icon"
          />
        )}
        {data.isActive === 1 && [7, 8].includes(data.status) && (
          <Image
            src={cancelIcon}
            onClick={handleSolutionInValidate}
            alt={t("SOLUTION_ACTION_TOOLTIP_UNVALIDATE")}
            title={t("SOLUTION_ACTION_TOOLTIP_UNVALIDATE")}
            className="solutions-list__image-icon"
          />
        )}
        {data.isActive === 1 && [4, 5, 6].includes(data.status) && (
          <Image
            src={editIcon}
            onClick={editSolution}
            alt={t("SOLUTION_ACTION_TOOLTIP_EDIT")}
            title={t("SOLUTION_ACTION_TOOLTIP_EDIT")}
            className="solutions-list__image-icon"
          />
        )}
        {data.isActive === 1 && (
          <Image
            src={deleteIcon}
            onClick={handleSolutionDisable}
            alt={t("SOLUTION_ACTION_TOOLTIP_DELETE")}
            title={t("SOLUTION_ACTION_TOOLTIP_DELETE")}
            className="solutions-list__image-icon"
          />
        )}
      </>
      {isAddSolutionPopupVisible && (
        <AddEditSolution
          solution={currentSolution}
          id={data.id}
          onClose={closeSolutionCreationPopup}
          title={`${t("UPDATE")} ${t("MATCHING")}, #${data.id}`}
          enquiryService={enquiryService}
          enquirySubCategoryName={enquirySubCategoryName}
          enquirySubCategoryId={enquirySubCategoryId}
          enquiryId={enquiryId}
          countryId={countryId}
        />
      )}
      {isConfirmVisible && (
        <WarningPopUp
          title={t("SOLUTION_CONFIRMATION_BOX_DELETE")}
          message={t("SOLUTION_CONFIRMATION_BOX_DELETE_CONTENT")}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </FlexRow>
  );
};

SolutionsActions.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    isActive: PropTypes.number,
    status: PropTypes.number,
    priceType: PropTypes.number,
    solutionTypeId: PropTypes.number,
    selectedPrice: PropTypes.bool,
  }).isRequired,
  t: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
  enquiryService: PropTypes.string,
  enquirySubCategoryName: PropTypes.number,
  enquirySubCategoryId: PropTypes.string,
  enquiryId: PropTypes.number,
  countryId: PropTypes.number,
};
SolutionsActions.defaultProps = {
  enquiryService: null,
  enquirySubCategoryName: null,
  enquirySubCategoryId: null,
  enquiryId: null,
  countryId: null,
};
export default withTranslation()(SolutionsActions);
